import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface ILegislation {
    nome?: string,
    descricao?: string,
    orgaoLegislador?: string,
    arquivo?: string | File,
    uuid?: string,
}

const create = async (data: ILegislation): Promise<any | Error> => {
    try {
        await AuthService.verify();
    
        const token = await AuthService.getAccessToken();
    
        const response = await ApiBack.post('/legislacao', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}` 
            }
        });
    
        if (response.data) {
            return response.data;
        }
    
        return new Error('Erro ao criar nova legislação');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar legislação');
        }
    }
};

const list = async (): Promise<ILegislation[] | Error> => {
  await AuthService.verify();

  try {
      const token = await AuthService.getAccessToken();

      const response = await ApiBack.get('./legisllegislacaoes', {
          headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `${token}`
          }
      });

      if (response.data) {
          return response.data;
      }

      return new Error('Erro ao listar registros.');
  } catch (error) {
      console.error(error);
      return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
  }
};

const get = async(uuid: string): Promise<ILegislation | Error> => {

    await AuthService.verify();

    const token = await AuthService.getAccessToken();

    try {
        const { data } = await ApiBack.get('./legislacao', {
            params: { 'uuid': uuid },
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });
        if (data) {
            return data;
        }
        return new Error('Erro ao buscar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string}).message || 'Erro na requisição de.');
    }
};

const delet = async(uuid: string): Promise<any | Error> => {

    await AuthService.verify();
  
    try{
        const token = await AuthService.getAccessToken();
  
        const response = await ApiBack.delete('./legislacao', {
            headers: {
                Authorization: `${token}`
            },
            params: {
                'uuid': uuid
            }
        });
  
        if(response.data){
            return response.data; 
        }
  
        return new Error('Falha ao deletar registro');
    } catch (error) {
        Error((error as { message: string}).message || 'Erro ao deletar registro');
    }
  };

  const upgrade = async(uuid: string, data: ILegislation): Promise<any | Error> => {
      
    await AuthService.verify();
  
    try{
        const token = await AuthService.getAccessToken();
  
        const response = await ApiBack.put(`./legislacao?uuid=${uuid}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });
  
        if(response.data){
            return response.data;
        }
        
        return new Error('Falha ao atualizar registro');
    } catch (error) {
        return new Error((error as { menssage: string}).menssage || 'Error ao atualizar registro');
    }
  };

export const LegislationService = {
    create,
    list,
    get,
    delet, 
    upgrade
};